/* Acumen PDP below-cart — JS for interactive sections
   Reads BCPO option values via the app's own .bcpo-title / .bcpo-value pattern.
   Zero dependencies. Idempotent.
*/
(function () {
  'use strict';
  if (window.__acumenBelowInit) return;
  window.__acumenBelowInit = true;

  var root = document.querySelector('.acumen-below');
  if (!root) return;

  // ─── S4 Finishes: style toggle + click-to-preview ───
  var tabs = root.querySelectorAll('.acumen-below__finish-tab');
  var panels = root.querySelectorAll('.acumen-below__finish-panel');
  var heroImgs = root.querySelectorAll('.acumen-below__finish-raw-img');
  var layout = root.querySelector('.acumen-below__finish-layout');
  var timberPrefix = layout && layout.getAttribute('data-timber-prefix') || 'elm';
  var caption = root.querySelector('.acumen-below__finish-caption[data-role="hero-caption"]');
  var activeTab = root.querySelector('.acumen-below__finish-tab.is-active');
  var currentStyle = activeTab ? activeTab.getAttribute('data-target') : 'rustic';
  var activeSlug = null;

  function styleName(s) { return s === 'modern' ? 'Modern Planed' : 'Rustic Weathered'; }
  function timberLabel() { return timberPrefix === 'elm' ? 'Reclaimed Elm' : 'Rustic Pine'; }

  function updateHero() {
    heroImgs.forEach(function (img) {
      var isVisible = img.getAttribute('data-panel') === currentStyle;
      img.style.display = isVisible ? 'block' : 'none';
      if (!isVisible) return;
      if (activeSlug) {
        img.src = 'https://cdn.shopify.com/s/files/1/0017/0695/0720/files/' + timberPrefix + '_' + currentStyle + '_' + activeSlug + '_table.jpg';
      } else {
        img.src = img.getAttribute('data-raw');
      }
    });
    if (caption) {
      if (activeSlug) {
        var name = activeSlug.charAt(0).toUpperCase() + activeSlug.slice(1);
        var tile = root.querySelector('.acumen-below__finish-tile[data-slug="' + activeSlug + '"]');
        if (tile) name = tile.getAttribute('data-name') || name;
        caption.textContent = name + ' · ' + styleName(currentStyle) + ' ' + timberLabel();
      } else {
        caption.textContent = timberLabel() + ' · ' + styleName(currentStyle) + '. Click a finish to preview.';
      }
    }
  }

  if (currentStyle !== 'rustic') updateHero();

  tabs.forEach(function (t) {
    t.addEventListener('click', function (e) {
      e.preventDefault();
      currentStyle = t.getAttribute('data-target');
      tabs.forEach(function (x) { x.classList.toggle('is-active', x.getAttribute('data-target') === currentStyle); });
      panels.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-panel') === currentStyle); });
      updateHero();
    });
  });

  root.querySelectorAll('.acumen-below__finish-tile').forEach(function (tile) {
    tile.style.cursor = 'pointer';
    tile.addEventListener('click', function () {
      var slug = tile.getAttribute('data-slug');
      if (activeSlug === slug) { activeSlug = null; } else { activeSlug = slug; }
      root.querySelectorAll('.acumen-below__finish-tile').forEach(function (x) {
        x.classList.toggle('is-active', x.getAttribute('data-slug') === activeSlug);
      });
      updateHero();
    });
  });

  // ─── S11 Bench cross-sell CTA scroll-to ───
  root.querySelectorAll('.acumen-below__complete-cta[data-scroll-to]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      var sel = btn.getAttribute('data-scroll-to');
      var target = document.querySelector(sel);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  });

  // ─── S2 Live spec card from BCPO ───
  function readBcpo(title) {
    var norm = title.toLowerCase().replace(/[:\s]+$/, '');
    var titles = document.querySelectorAll('.bcpo-title');
    for (var i = 0; i < titles.length; i++) {
      var t = titles[i].textContent.trim().toLowerCase().replace(/[:\s]+$/, '');
      if (t === norm) {
        var val = titles[i].parentElement && titles[i].parentElement.querySelector('.bcpo-value');
        if (val) return val.textContent.trim();
      }
    }
    return null;
  }

  function seatsFor(length, width) {
    // length + width in cm. Returns "6 people" / "6-8 people" etc.
    var L = parseInt(length || '', 10);
    var W = parseInt(width || '', 10);
    if (!L || !W) return null;
    // Perimeter chairs: 60cm per chair space along the long side
    var perSide = Math.max(1, Math.floor(L / 60));
    // End chairs added when length >= 180 and width >= 90 (fits comfortably)
    var ends = (L >= 180 && W >= 90) ? 2 : 0;
    var min = perSide * 2 + ends;
    // Snug packing adds 1 per side on 180cm+
    var max = min + (L >= 180 ? 2 : 0);
    if (min === max) return min + ' people';
    return min + '-' + max + ' people';
  }

  function updateSpec() {
    var card = root.querySelector('.acumen-below__spec-card');
    if (!card) return;

    var length = readBcpo('TABLE LENGTH');
    var width  = readBcpo('TABLE WIDTH');
    var style  = readBcpo('TIMBER STYLE');
    var colour = readBcpo('COLOUR') || readBcpo('WAX FINISH');
    var wtype  = readBcpo('TABLE TOP FINISH');
    var lfin   = readBcpo('LEG FINISH');
    var edge   = readBcpo('EDGE PROFILE');
    var leaves = readBcpo('REQUIRE EXTENDABLE LEAFS?') || readBcpo('REQUIRE EXTENDABLE LEAVES?');
    var leafsz = readBcpo("LEAF SIZE'S") || readBcpo('LEAF SIZE');

    setSpec('timber-style', style);
    setSpec('wax-colour', combine(colour, wtype));
    var thick  = readBcpo('TIMBER THICKNESS');
    setSpec('dimensions', dims(length, width, thick));
    setSpec('seats', seatsFor(length, width));
    setSpec('leaves', leavesDisplay(leaves, leafsz));
    setSpec('leg-finish', lfin);
    setSpec('edge', edge);
  }

  function combine(a, b) {
    if (a && b) return a + ' · ' + b;
    return a || b || null;
  }
  function dims(l, w, t) {
    if (!l || !w) return null;
    var mm = (t && /(\d+)\s*mm/i.test(t)) ? RegExp.$1 + 'mm' : '45mm'; /* table tops sell 35/50mm; tables are 45mm */
    return '<b>' + l + ' × ' + w + ' × ' + mm + '</b>';
  }
  function leavesDisplay(yn, sz) {
    if (!yn) return null;
    if (/^yes/i.test(yn) && sz) return 'Yes · ' + sz + ' per leaf';
    return yn;
  }

  function setSpec(key, value) {
    if (value === null || value === undefined || value === '') return;
    var row = root.querySelector('[data-spec="' + key + '"] .acumen-below__spec-val');
    if (row) row.innerHTML = value;
  }

  // Initial passes + observe BCPO for changes
  updateSpec();
  setTimeout(updateSpec, 500);
  setTimeout(updateSpec, 1500);
  setTimeout(updateSpec, 3000);

  // MutationObserver on the BCPO container(s)
  var bcpo = document.getElementById('bcpo');
  if (bcpo && 'MutationObserver' in window) {
    var mo = new MutationObserver(function () { updateSpec(); });
    mo.observe(bcpo, { childList: true, subtree: true, characterData: true });
  }
  // Also listen for form change events (radio/select changes)
  var form = document.querySelector('.product-form, form[action^="/cart/add"]');
  if (form) {
    form.addEventListener('change', updateSpec);
    form.addEventListener('input', updateSpec);
  }
})();
